export default function Duck(scene, level) {
  const {
    player
  } = level;
  return active => {
    player.ducking = active;
  };
}